import { getKPIType } from '../types/SalonInputData';
import { KpiTitle } from '../types/SalonKpiData';

/**
 * Returns the field config for a KPI, including inputProps and validate function.
 */
export function getKpiFieldConfig(item: KpiTitle) {
  const type = getKPIType(item);
  if (type === 'percentage') {
    return {
      id: item,
      label: item,
      cellSize: 12,
      inputProps: {
        inputMode: 'decimal',
        pattern: '^\\d{0,3}(\\.\\d{0,2})?$',
        min: 0.01,
        max: 100,
        step: 0.01,
      },
      ...(item === KpiTitle.spRetention && { required: true }),
      validate: (value: string) =>
        value === '' ||
        (/^\d{1,3}(\.\d{1,2})?$/.test(value) &&
          parseFloat(value) >= 0.01 &&
          parseFloat(value) <= 100)
          ? undefined
          : 'Enter a percentage between 0.01 and 100 (max 2 decimals)',
    };
  }
  if (type === 'money') {
    return {
      id: item,
      label: item,
      cellSize: 12,
      inputProps: {
        inputMode: 'decimal',
        pattern: '^\\d{1,13}(\\.\\d{0,2})?$',
        min: 0.01,
        max: 10000000000000,
        step: 0.01,
      },
      validate: (value: string) =>
        value === '' ||
        (/^\d{1,13}(\.\d{1,2})?$/.test(value) &&
          parseFloat(value) >= 0.01 &&
          parseFloat(value) <= 10000000000000)
          ? undefined
          : 'Enter an amount between 0.01 and 10,000,000,000,000 (max 2 decimals)',
    };
  }
  // integer
  return {
    id: item,
    label: item,
    cellSize: 12,
    inputProps: {
      inputMode: 'numeric',
      pattern: '^\\d+$',
      min: 1,
      step: 1,
    },
    validate: (value: string) =>
      value === '' || (/^\d+$/.test(value) && parseInt(value, 10) >= 1)
        ? undefined
        : 'Enter a positive whole number (min 1)',
  };
}
